import {
  UserChangeIntroducerDataRequestDto,
  UserIntroducerResponseDto,
  ReadUsersForReassignIntroducerResponseDto,
  ReadUserReferralsRequestDto,
  ReadUserReferralsResponseDto,
  DeleteUserReferralRequestDto,
  DeleteUserReferralResponseDto,
  UpdateUserReferralRequestDto,
  UpdateUserReferralResponseDto,
  CreateUserReferralRequestDto,
  CreateUserReferralResponseDto,
  IUser,
} from '@sparling/financial-common'
import axios, { AxiosRequestConfig } from 'axios'

export const fetchUserReferrals = async (
  { token, introducerId, ...params }: ReadUserReferralsRequestDto & { token: string },
  options: AxiosRequestConfig = {},
): Promise<ReadUserReferralsResponseDto> => {
  const response = await axios.get<ReadUserReferralsResponseDto>(
    `${process.env.REACT_APP_SERVER_URL}/crm/user-referrals/${introducerId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
      params,
      ...options,
    },
  )

  return response.data
}

export const deleteUserReferrals = async (
  { token, ...data }: DeleteUserReferralRequestDto & { token: string },
  options: AxiosRequestConfig = {},
): Promise<DeleteUserReferralResponseDto> => {
  const response = await axios.delete<DeleteUserReferralResponseDto>(
    `${process.env.REACT_APP_SERVER_URL}/crm/user-referrals`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
      data,
    },
  )

  return response.data
}

export const introducerDataUpdate = async (
  { token, idSf, ...rest }: UserChangeIntroducerDataRequestDto & { idSf: string } & { token: string },
  options: AxiosRequestConfig = {},
): Promise<UserIntroducerResponseDto> => {
  const response = await window.fetch(`${process.env.REACT_APP_SERVER_URL}/crm/user/${idSf}/introducer-data-update`, {
    body: JSON.stringify(rest),
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      ...options.headers,
    },
    ...options,
  })
  return response.json()
}

export const fetchUsersForReassign = async (
  { token }: { token: string },
  options: AxiosRequestConfig = {},
): Promise<ReadUsersForReassignIntroducerResponseDto> => {
  const response = await axios.get<ReadUsersForReassignIntroducerResponseDto>(
    `${process.env.REACT_APP_SERVER_URL}/crm/users-for-reassign`,
    {
      params: { limit: 0 },
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    },
  )
  return response.data
}

export const fetchAssignableReferrals = async (
  { token }: { token: string },
  options: AxiosRequestConfig = {},
): Promise<{ data: IUser[] }> => {
  const response = await axios.get<{ data: IUser[] }>(`${process.env.REACT_APP_SERVER_URL}/crm/assignable-referrals`, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      ...options.headers,
    },
    ...options,
  })
  return response.data
}

export const assignIntroducerUser = async (
  { token, ...params }: { token: string } & CreateUserReferralRequestDto,
  options: AxiosRequestConfig = {},
): Promise<CreateUserReferralResponseDto> => {
  const response = await axios.post<CreateUserReferralResponseDto>(
    `${process.env.REACT_APP_SERVER_URL}/crm/user-referrals`,
    params,
    {
      headers: {
        ...options.headers,
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      ...options,
    },
  )
  return response.data
}

export const reassignIntroducerUser = async (
  { token, ...params }: { token: string } & UpdateUserReferralRequestDto,
  options: AxiosRequestConfig = {},
): Promise<UpdateUserReferralResponseDto> => {
  const response = await axios.patch<UpdateUserReferralResponseDto>(
    `${process.env.REACT_APP_SERVER_URL}/crm/user-referrals`,
    params,
    {
      headers: {
        ...options.headers,
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      ...options,
    },
  )
  return response.data
}
